import { set } from '@/utils/vuex'

export default {
  setTankTypes: set('tankTypes')
}
